import type {
  PeekPriceModalFerryPlusHotelItinerary,
  PeekPriceModalFlightPlusHotelItinerary,
  PeekPriceModalHotelOnlyItinerary,
  PeekPriceModalItinerary,
  PeekPriceModalNewModalItinerary,
  PeekPriceModalOldModalItinerary,
  PeekPriceModalUnavailableFerryPlusHotel,
  PeekPriceModalUnavailableFlightPlusHotel,
} from './itinerary';
import { PeekPriceModalItineraryType } from './itinerary';

export function isPeekPriceModalOldModalItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalOldModalItinerary {
  return itinerary.type === PeekPriceModalItineraryType.OldModal;
}

export function isPeekPriceModalHotelOnlyItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalHotelOnlyItinerary {
  return itinerary.type === PeekPriceModalItineraryType.HotelOnly;
}

export function isPeekPriceModalFlightPlusHotelItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalFlightPlusHotelItinerary {
  return itinerary.type === PeekPriceModalItineraryType.FlightPlusHotel;
}

export function isPeekPriceModalUnavailableFlightPlusHotel(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalUnavailableFlightPlusHotel {
  return (
    itinerary.type === PeekPriceModalItineraryType.UnavailableFlightPlusHotel
  );
}

export function isPeekPriceModalFerryPlusHotelItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalFerryPlusHotelItinerary {
  return itinerary.type === PeekPriceModalItineraryType.FerryPlusHotel;
}

export function isPeekPriceModalUnavailableFerryPlusHotel(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalUnavailableFerryPlusHotel {
  return (
    itinerary.type === PeekPriceModalItineraryType.UnavailableFerryPlusHotel
  );
}

export function isPeekPriceModalNewModalItinerary(
  itinerary: PeekPriceModalItinerary
): itinerary is PeekPriceModalNewModalItinerary {
  return (
    isPeekPriceModalHotelOnlyItinerary(itinerary) ||
    isPeekPriceModalFlightPlusHotelItinerary(itinerary) ||
    isPeekPriceModalUnavailableFlightPlusHotel(itinerary) ||
    isPeekPriceModalFerryPlusHotelItinerary(itinerary) ||
    isPeekPriceModalUnavailableFerryPlusHotel(itinerary)
  );
}
